const fadein = element => {
  const $ = window.jQuery;
  $ && $(element.querySelectorAll('.fadein')).on('inview', (event, isInView) => {
    const $self = $(event.target);
    isInView && $self.delay(120).queue(() => $self.stop().addClass('fadeinOn').dequeue());
  });
};

const _script = [];
const script = url => {
  if (_script.indexOf(url) < 0) {
    _script.push(url);
  } else {
    return;
  }
  return new Promise((resolve) => {
    const element = document.createElement('script');
    element.addEventListener('load', resolve);
    element.defer = true;
    element.src = url;
    document.head.appendChild(element);
  });
};

export default {
  sleep: a => new Promise(b => setTimeout(b, a)),
  money: a => isNaN(a) ? '' : '¥' + Number(a).toLocaleString(),
  fadein: a => fadein(a),
  script: async a => await script(a),
};
